import React from "react";
import { Link } from "react-router-dom";
import { SlideshowImage } from "cms/components/components/hero-slideshow/display/slideshow-image";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap/index";
import "./hero-slideshow-slide.css";

const HeroSlideshowSlide = (props) => {
    const images = props?.images;
    const slides = props?.slides;
    const index = props?.index;
    const total = props?.total;
    const moveIndex = props?.moveIndex;
    
    const slide = slides[index];
    const title = slide?.title;
    const description = slide?.description;
    const link = slide?.link;
    const text = link?.text;
    const link_url = link?.url;
    
    const image = Array.isArray(images) && images[index];
    const slideImage = slide?.image;
    const settings = slideImage?.settings;
    
    const handleDotClick = (dotIndex) => {
        moveIndex(dotIndex - index);
    };


    return (
        <div className={"slideshow-slide"}>
            
            <div className="home-banner">
                <SlideshowImage
                    image={image}
                    slide={slide}
                    settings={settings}
                />
            </div>
            
            <div 
                className="home-banner-content"
                style={{
                    backgroundImage: image?.src ? `url(${image.src})` : "none",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative"
                }}
            >
                <div className="content-overlay">
                    <div className='slideshow-slide-title'>{title}</div>
                    
                    <RichTextPreview
                        richtext={description}
                        className='slideshow-slide-description'
                    />
                    
                    <div className="controls">
                        
                        {link_url &&
                            <Link to={link_url} className='slideshow-slide-link'>
                                {text}
                            </Link>
                        }
                        
                        <div className="slide-controls">
                            <div className="slide-dots">
                                {Array.from({ length: total }, (_, i) => (
                                    <button
                                        key={i}
                                        className={`slide-dot ${i === index ? "active" : ""}`}
                                        aria-label={`Go to slide ${i + 1}`}
                                        onClick={() => handleDotClick(i)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
    );
};

export { HeroSlideshowSlide }; 
